export default "__VITE_ASSET__CiC6WBCW__"